import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const DeleteIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        height="20"
        width="20"
        viewBox="0 0 20 20"
        fill={theme.colors.primary.variant8}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.5 17q-.625 0-1.062-.438Q5 16.125 5 15.5v-10H4V4h4V3h4v1h4v1.5h-1v10q0 .625-.438 1.062Q14.125 17 13.5 17Zm7-11.5h-7v10h7ZM8 14h1.5V7H8Zm2.5 0H12V7h-1.5Zm-4-8.5v10Z" />
      </svg>
    </Icon>
  );
};

export default DeleteIcon;
